// extracted by mini-css-extract-plugin
export var completionBody = "_jz-2";
export var completionCard = "_jz-0";
export var completionFooter = "_jz-3";
export var completionTitle = "_jz-1";